import { render, staticRenderFns } from "./i18n.vue?vue&type=template&id=8c6e1042&"
import script from "./i18n.vue?vue&type=script&lang=js&"
export * from "./i18n.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/tempos21/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('8c6e1042', component.options)
    } else {
      api.reload('8c6e1042', component.options)
    }
    module.hot.accept("./i18n.vue?vue&type=template&id=8c6e1042&", function () {
      api.rerender('8c6e1042', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Pages/Settings/i18n.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/Settings/i18n.vue
// module id = XfaE
// module chunks = 0